import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'overview'
})
export class OverviewPipe implements PipeTransform {

  transform(value: string, limit?: number): any {

    if (!value || value.length === 0) { return }

    const lmt = limit ? limit : 50;
    const regex = /(<([^>]+)>)/ig;

    const plainText = value.replace(regex, '');

    return plainText.length > lmt ? plainText.slice(0, lmt).concat('...') : plainText;
  }

}
